import { Link } from '@betterment/samba-react';

import { SUPPORT_EMAIL } from '../constants';

export const SupportEmail: React.FC = () => (
  <Link href={`mailto:${SUPPORT_EMAIL}`} variant="textPrimary">
    {SUPPORT_EMAIL}
  </Link>
);
